import type { ComponentType } from 'react';
import {
  BoldOutlined,
  ItalicOutlined,
  StrikethroughOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
} from '@ant-design/icons';
import type { Editor } from '@tiptap/react';

interface MarkButton {
  key: string;
  Icon: ComponentType;
  label: string;
  mark: string;
  type: 'mark';
}

interface NodeButton {
  key: string;
  Icon: ComponentType;
  label: string;
  node: string;
  type: 'node';
}

export type ToolbarButton = MarkButton | NodeButton;

export const MARK_BUTTONS: ToolbarButton[] = [
  {
    key: 'bold',
    Icon: BoldOutlined,
    label: 'Bold',
    mark: 'bold',
    type: 'mark',
  },
  {
    key: 'italic',
    Icon: ItalicOutlined,
    label: 'Italic',
    mark: 'italic',
    type: 'mark',
  },
  {
    key: 'strike',
    Icon: StrikethroughOutlined,
    label: 'Strikethrough',
    mark: 'strike',
    type: 'mark',
  },
];

export const LIST_BUTTONS: ToolbarButton[] = [
  {
    key: 'bulletList',
    Icon: UnorderedListOutlined,
    label: 'Bullet list',
    node: 'bulletList',
    type: 'node',
  },
  {
    key: 'orderedList',
    Icon: OrderedListOutlined,
    label: 'Ordered list',
    node: 'orderedList',
    type: 'node',
  },
];

export const ALL_BUTTONS: ToolbarButton[] = [...MARK_BUTTONS, ...LIST_BUTTONS];

export function isButtonActive(editor: Editor, button: ToolbarButton): boolean {
  return button.type === 'mark'
    ? editor.isActive(button.mark)
    : editor.isActive(button.node);
}

export function executeButton(editor: Editor, button: ToolbarButton): void {
  if (button.type === 'mark') {
    editor.chain().focus().toggleMark(button.mark).run();
  } else if (button.node === 'bulletList') {
    editor.chain().focus().toggleBulletList().run();
  } else {
    editor.chain().focus().toggleOrderedList().run();
  }
}
